import { Component, OnInit } from '@angular/core';
import { ProductConfig } from '../../../Models/AdminRights/product-config';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser'
import { AdminRightsService } from '../../../Services/AdminRights/admin-rights.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-product-config',
  templateUrl: './product-config.component.html',
  styleUrls: ['./product-config.component.css']
})
export class ProductConfigComponent implements OnInit {
  loader = 'none';
  loggedInUser: string = localStorage.getItem('dsu_userId')
  productConfigObj: ProductConfig[] = [];
  newArray: ProductConfig[];
 

  constructor(private adminConfiguration: AdminRightsService, private toastr: ToastrService) { }


  ngOnInit() {
    this.productConfig(this.loggedInUser);

  }
  productConfig(userId: any) {
    this.loader = 'block';
    this.adminConfiguration.productConfig(userId)
      .subscribe((resData: any) => {
        if (resData.status) {
          this.productConfigObj = resData.data;
          this.loader = 'none';
        }
        else {
        }

      }
      );
  }
  UpdateProductVisibility() {
    let showProduct: boolean = false;
    this.productConfigObj.forEach(function (ele) {
      if (ele.isDisplay == true) {
        return showProduct = true;
      }
    });
    if (showProduct) {
      this.adminConfiguration.updateProductConfiguration(this.productConfigObj, this.loggedInUser)
        .subscribe((resdata: any) => {
          if (resdata.status) {
            this.productConfigObj;
            this.toastr.success('Data Updated Successfully.');
          }
          else {

          }
        }, error => {
          //loader will be display none;
        });
    }
    else {
      this.toastr.error('Please select atleast one Product.');
    }

  }

  get selectedOptions() {
    return this.productConfigObj
      .filter(opt => opt.isDisplay)
      .map(opt => opt.productName)
  }

  Cancel() {
    this.loader = 'block';
    this.productConfig('');
    this.loader = 'none';
  }
  allProducts(event) {
    const checked = event.target.checked;
    this.productConfigObj.forEach(item => item.isDisplay = true);
  }

}


